import React from 'react'

function Cookies() {
  return (
    <div>Cookies</div>
  )
}

export default Cookies